import {
  deMessages,
  enMessages,
  esMessages,
  frMessages,
  itMessages,
  ptMessages,
  skMessages,
} from '.';

const catalog = {
  en: { ...enMessages },
  es: { ...esMessages },
  de: { ...deMessages },
  fr: { ...frMessages },
  it: { ...itMessages },
  pt: { ...ptMessages },
  sk: { ...skMessages },
};

export default catalog;
